'use client';

import Link from 'next/link';
import { ImageComponent } from '@/components/Image';
import { getFooterImages } from './helpers';

export const FooterImages = () => {
  const footerImages = getFooterImages();

  return footerImages.map(({ href, alt, ...props }, index) =>
    href ? (
      <Link
        aria-label={alt}
        href={href}
        key={index}
        rel="noreferrer"
        target="_blank"
      >
        <ImageComponent {...props} alt={alt} />
      </Link>
    ) : (
      <ImageComponent key={index} {...props} alt={alt} />
    )
  );
};
